import React, { useState } from 'react';
import { useStore } from '../hooks/useStore';
import { CheckCircleIcon } from 'lucide-react';
import { DoorStrip, DOOR_PALETTE, WOOD_TEXTURE_CSS } from '../components/DoorStrip';
export function ReservasPage() {
  const {
    addReservation
  } = useStore();
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    date: '',
    time: '',
    guests: 2,
    notes: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    addReservation(formData);
    setSubmitted(true);
  };
  const reset = () => {
    setFormData({
      name: '',
      phone: '',
      email: '',
      date: '',
      time: '',
      guests: 2,
      notes: ''
    });
    setSubmitted(false);
  };
  if (submitted) {
    return <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4" data-id="element-676">
        <div className="text-center max-w-md" data-id="element-677">
          <div className="w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-678">
            <CheckCircleIcon className="w-10 h-10 text-emerald-600" data-id="element-679" />
          </div>
          <h2 className="font-display text-4xl font-extrabold text-stone-900 mb-4 tracking-tight" data-id="element-680">
            ¡Reserva Confirmada!
          </h2>
          <p className="text-stone-500 mb-10 text-lg font-medium" data-id="element-681">
            Te contactaremos al <strong data-id="element-682">{formData.phone}</strong> para confirmar
            los detalles.
          </p>
          <button onClick={reset} className="px-8 py-4 bg-black text-white rounded-xl font-bold text-sm hover:bg-stone-800 transition-colors shadow-lg" data-id="element-683">
            Nueva Reserva
          </button>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-white" data-id="element-684">
      {/* ── HERO HEADER ── */}
      <div className="relative bg-black overflow-hidden pt-24 pb-12 px-6 text-center" data-id="element-685">
        <div className="relative z-10" data-id="element-686">
          <img src="https://cdn.magicpatterns.com/uploads/ewfDCj5QKNDNeQRsTcwjBG/logo_de_Junquito_Gas_(4).ai_(4).png" alt="La Cochera" className="h-12 mx-auto mb-6" data-id="element-687" />
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-white tracking-tight mb-6" data-id="element-688">
            Reserva tu Mesa
          </h1>
          <div className="flex justify-center gap-1 mb-0" data-id="element-689">
            {DOOR_PALETTE.map((c, i) => <div key={i} className="w-8 h-1 rounded-full" style={{
            backgroundColor: c
          }} data-id="element-690" />)}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0" data-id="element-691">
          <DoorStrip height="h-2" data-id="element-692" />
        </div>
      </div>

      {/* ── SECTION BANNER ── */}
      <div className="relative overflow-hidden" style={{
      backgroundColor: DOOR_PALETTE[3],
      backgroundImage: WOOD_TEXTURE_CSS
    }} data-id="element-693">
        <div className="max-w-5xl mx-auto px-6 py-6 flex items-center justify-between" data-id="element-694">
          <div data-id="element-695">
            <h2 className="font-display text-3xl font-extrabold text-white tracking-tight" data-id="element-696">
              Detalles
            </h2>
            <p className="text-white/70 text-xs font-bold uppercase tracking-widest pl-1" data-id="element-697">
              Asegura tu lugar
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-16 flex flex-col lg:flex-row gap-12" data-id="element-698">
        {/* Left - Image & Info */}
        <div className="lg:w-2/5 rounded-2xl overflow-hidden relative min-h-[400px] lg:min-h-0 shadow-2xl" data-id="element-699">
          <img src="https://images.unsplash.com/photo-1559329007-40df8a9345d8?w=800&q=80" alt="Restaurante" className="w-full h-full object-cover absolute inset-0" data-id="element-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" data-id="element-701" />
          <div className="relative z-10 p-8 flex flex-col justify-end h-full" data-id="element-702">
            <h2 className="font-display text-3xl font-bold text-white mb-4" data-id="element-703">
              Tu mesa te espera
            </h2>
            <p className="text-white/80 text-sm leading-relaxed mb-8 font-medium" data-id="element-704">
              Ambiente relajado, música suave y sabores inolvidables.
            </p>
            <div className="space-y-4 text-sm text-white font-medium" data-id="element-705">
              <p data-id="element-706">📍 Plaza Jardines, Santiago</p>
              <p data-id="element-707">📞 +1 (809) 247-7373</p>
              <p data-id="element-708">🕐 10:00 AM - 11:00 PM</p>
            </div>
          </div>
        </div>

        {/* Right - Form */}
        <div className="lg:w-3/5" data-id="element-709">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-710">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-711">
              <div data-id="element-712">
                <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-713">
                  Nombre
                </label>
                <input type="text" required className="w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:ring-2 focus:ring-black focus:border-black outline-none transition-all text-sm font-medium" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} placeholder="Tu nombre" data-id="element-714" />
              </div>
              <div data-id="element-715">
                <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-716">
                  Teléfono
                </label>
                <input type="tel" required className="w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:ring-2 focus:ring-black focus:border-black outline-none transition-all text-sm font-medium" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} placeholder="(809) 000-0000" data-id="element-717" />
              </div>
            </div>
            <div data-id="element-718">
              <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-719">
                Email
              </label>
              <input type="email" required className="w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:ring-2 focus:ring-black focus:border-black outline-none transition-all text-sm font-medium" value={formData.email} onChange={e => setFormData({
              ...formData,
              email: e.target.value
            })} placeholder="correo@ejemplo.com" data-id="element-720" />
            </div>
            <div className="grid grid-cols-3 gap-4" data-id="element-721">
              <div data-id="element-722">
                <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-723">
                  Fecha
                </label>
                <input type="date" required className="w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:ring-2 focus:ring-black focus:border-black outline-none transition-all text-sm font-medium" value={formData.date} onChange={e => setFormData({
                ...formData,
                date: e.target.value
              })} data-id="element-724" />
              </div>
              <div data-id="element-725">
                <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-726">
                  Hora
                </label>
                <input type="time" required className="w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:ring-2 focus:ring-black focus:border-black outline-none transition-all text-sm font-medium" value={formData.time} onChange={e => setFormData({
                ...formData,
                time: e.target.value
              })} data-id="element-727" />
              </div>
              <div data-id="element-728">
                <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-729">
                  Personas
                </label>
                <select className="w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:ring-2 focus:ring-black focus:border-black outline-none transition-all text-sm font-medium" value={formData.guests} onChange={e => setFormData({
                ...formData,
                guests: parseInt(e.target.value)
              })} data-id="element-730">
                  {[...Array(12)].map((_, i) => <option key={i + 1} value={i + 1} data-id="element-731">
                      {i + 1} {i === 0 ? 'persona' : 'personas'}
                    </option>)}
                </select>
              </div>
            </div>
            <div data-id="element-732">
              <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-733">
                Notas (Opcional)
              </label>
              <textarea className="w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:ring-2 focus:ring-black focus:border-black outline-none transition-all text-sm font-medium h-32 resize-none" value={formData.notes} onChange={e => setFormData({
              ...formData,
              notes: e.target.value
            })} placeholder="Alergias, celebración especial..." data-id="element-734" />
            </div>
            <button type="submit" className="w-full py-4 bg-black text-white font-bold rounded-xl hover:bg-stone-800 transition-colors shadow-lg text-sm uppercase tracking-widest" data-id="element-735">
              Confirmar Reserva
            </button>
          </form>
        </div>
      </div>
    </div>;
}